import { createAction } from "@ngrx/store";

import { AppError } from "../../app-error/app-error.model";

import { SessionSummary } from "./session-summary.model";

const ACTION_PREFIX = "[Session summary]";

/**
 * @deprecated [fabric-deprecated] - Use SessionSummaryService from app-responsible-gaming instead
 */
export namespace SessionSummaryAction {
	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const fetch = createAction(`${ACTION_PREFIX} fetch`, (logout?: boolean) => ({ logout }));

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const fetchSuccess = createAction(`${ACTION_PREFIX} fetch success`, (sessionSummary: SessionSummary) => ({
		sessionSummary,
	}));

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const fetchFailure = createAction(`${ACTION_PREFIX} fetch failure`, (error: AppError) => ({ error }));

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const fetchBeforeLogoutSuccess = createAction(
		`${ACTION_PREFIX} fetch before logout success`,
		(sessionSummary: SessionSummary) => ({ sessionSummary })
	);

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const fetchBeforeLogoutFailure = createAction(
		`${ACTION_PREFIX} fetch before logout failure`,
		(error: AppError) => ({ error })
	);

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const fetchBeforeLogoutCancel = createAction(`${ACTION_PREFIX} fetch before logout cancel`);

	export const clear = createAction(`${ACTION_PREFIX} clear`);
}
